const addendum = {
  pathToPdfFolder: "",
  showModification: true
};

addendum.init = function (pathToPdfFolder, pathToAdditifs) {
  addendum.pathToPdfFolder = pathToPdfFolder

  $(document).ready(function () {
    $.ajax({
      type: "GET",
      url: pathToAdditifs,
      dataType: "text",
      async: true,
      error: function (jqXHR, textStatus, errorThrown) {
        $("#eguide_addendum").hide()
      }
    }).done(function (data) {
      var x2js = new X2JS()
      var jsonData = x2js.xml_str2json(data);

      addendum.createContent(jsonData)
    });

    $("#eguide_addendum").on("click", (function () {
      if ($("#content_addendum").is(':visible')) {
        $("#content_addendum").hide()
      }
      else {
        $("#content_addendum").show()
      }
    }))

    $(document).on("click", (function (event) {
      if (!$(event.target).closest('#content_addendum').length && !$(event.target).closest('#eguide_addendum').length) {
        if ($('#content_addendum').is(":visible")) {
          $('#content_addendum').hide();
        }
      }
    }))
  })

}

addendum.createContent = function (jsonData) {
  if ( jsonData.liste.topicref === undefined ) {
    $("#eguide_addendum").hide()
    return
  }

  var topicref;
  if (Array.isArray(jsonData.liste.topicref)) {
    jsonData.liste.topicref.sort(function (topicrefA, topicrefB) {
      return (topicrefA._title.length - topicrefB._title.length)
    })

    topicref = jsonData.liste.topicref;
  }
  else {
    topicref = []
    topicref.push(jsonData.liste.topicref)
  }

  var nbAddendum = topicref.length

  if (nbAddendum > 0) {
    $("#eguide_addendum").show()
    $("#nb_addendum").text(nbAddendum);

    var callback = {
      addendumData: jsonData.liste,
      callback: function (template) {
        this.addendumData["pathToPdfFolder"] = addendum.pathToPdfFolder;

        var htmlText = Mustache.render(template, this.addendumData);
        var $htmlContent = $(htmlText);

        $($htmlContent).find("[data-i18n]").i18n();

        $("#content_addendum").append($htmlContent);

        addendum.initCheckbox();
      }
    }

    getContentsWithCallback("../../../../app/assets/template/addendum", "mustache", $.proxy(callback.callback, callback));
  }
  else {
    $("#eguide_addendum").hide()
  }
}

addendum.openPdf = function (pathToPdf) {
  window.open(pathToPdf, '_blank');
}

addendum.initCheckbox = function () {
  $('#checkbox_show_modification').change(function () {
    addendum.showModification = this.checked;
    navigationWeb.showModification(this.checked, $("#summary-tree-content"));
  });
}

addendum.loadPage = function (url) {
  if ($("#content_addendum").is(':visible')) {
    $("#content_addendum").hide();
  }

  var id = navigationWeb.mapSummaryHrefId[url]
  var key = navigationWeb.mapSummaryUrlKey[id]

  navigationWeb.activateItemSummaryFromId(key)
  pap.loadPage(id)
}